module.exports = __webpack_public_path__ + "img/naked-insurance-banner-square-5.de2df4ce.jpg";